import { render, staticRenderFns } from "./otherStyle.vue?vue&type=template&id=3592e180&scoped=true"
import script from "./otherStyle.vue?vue&type=script&lang=js"
export * from "./otherStyle.vue?vue&type=script&lang=js"
import style0 from "./otherStyle.vue?vue&type=style&index=0&id=3592e180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3592e180",
  null
  
)

export default component.exports